import React from 'react'

const EditButton = ({ onClick, disabled = false, isLoading = false, title = "Edit", label = "Edit", loadingLabel = "Updating..." }) => {
	return (
		<button
			onClick={onClick}
			disabled={disabled || isLoading}
			className="inline-flex items-center px-3 py-2 text-sm font-medium text-blue-600 bg-blue-100 rounded-lg hover:bg-blue-200 focus:ring-4 focus:outline-none focus:ring-blue-300 disabled:opacity-50 disabled:cursor-not-allowed"
			title={title}
		>
			<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
				<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
			</svg>
			<span className="ml-1">{isLoading ? loadingLabel : label}</span>
		</button>
	)
}

export default EditButton
